import { render, staticRenderFns } from "./GenerateRed.vue?vue&type=template&id=34ba822c&"
import script from "./GenerateRed.vue?vue&type=script&lang=js&"
export * from "./GenerateRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports